import { v4 as uuid } from 'uuid';
import { useIntl, defineMessages } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  CardReadMore,
} from 'design-react-kit';
import {
  richTextHasContent,
  RichTextRender,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import {
  ListingLinkMore,
  Icon,
} from 'design-comuni-plone-theme/components/ItaliaTheme';

const messages = defineMessages({
  involved_in_label: {
    id: 'involved_in_label',
    defaultMessage: 'Si occupa di',
  },
  card_detail_label: {
    id: 'card_detail_label',
    defaultMessage: 'Vedi',
  },
});

const ImolaDoveTemplate = ({
  items,
  linkTitle,
  linkHref,
  linkAlign,
  linkmore_id_lighthouse,
  isEditMode,
  id_lighthouse,
}) => {
  const resultsUID = uuid();
  const intl = useIntl();

  return (
    <div className="imola-dove">
      <div className="container px-4">
        {items.map((item, index) => {
          const address = `${item.street} - ${item.city}, ${item.zip_code}`;
          return (
            <div
              className="card-wrapper w-100 mb-3"
              id={resultsUID + '_results'}
            >
              <Card
                className="rounded shadow no-after"
                noWrapper
                teaser
                key={index}
              >
                <CardBody>
                  <CardTitle tag="h3" className="mb-0">
                    <Icon icon="map-marker-alt" className="me-2" />
                    <UniversalLink
                      item={item}
                      href={item['@id']}
                      data-element={id_lighthouse}
                      tabIndex={0}
                    >
                      {item.title}
                    </UniversalLink>
                  </CardTitle>
                  <div className="description">{item.description}</div>
                  <div className="involved-in-label fst-italic">
                    {intl.formatMessage(messages.involved_in_label)}:{' '}
                    {item.involved_in?.length > 0 &&
                      item.involved_in.map((el, index) => {
                        if (index + 1 < item.involved_in.length) {
                          return <span>{el.title} - </span>;
                        } else {
                          return <span>{el.title}</span>;
                        }
                      })}
                  </div>
                  <div className="indirizzo">{address}</div>
                  <div className="contacts">
                    {item.recapiti_web?.length > 0 && (
                      <div className="recapiti-web">
                        <UniversalLink
                          item={item.recapiti_web[0]}
                          href={item.recapiti_web[0].value}
                          overrideMarkSpecialLinks={true}
                        >
                          {item.recapiti_web[0].label}
                        </UniversalLink>
                      </div>
                    )}
                    {item.email && (
                      <div className="email">
                        {' '}
                        <UniversalLink
                          item={item.email}
                          href={`mailto:${item.email}`}
                          overrideMarkSpecialLinks={true}
                        >
                          {item.email}
                        </UniversalLink>
                      </div>
                    )}
                    {richTextHasContent(item.phone) && (
                      <div className="phone">
                        <RichTextRender data={item.phone} serif={false} />
                      </div>
                    )}
                  </div>
                  <CardReadMore
                    iconName="it-arrow-right"
                    tag={UniversalLink}
                    item={item}
                    href={item['@id']}
                    text={intl.formatMessage(messages.card_detail_label)}
                    aria-hidden="true"
                  />
                </CardBody>
              </Card>
            </div>
          );
        })}
      </div>

      <ListingLinkMore
        title={linkTitle}
        href={linkHref}
        className="my-4"
        linkAlign={linkAlign}
        linkmoreIdLighthouse={linkmore_id_lighthouse}
      />
    </div>
  );
};

export default ImolaDoveTemplate;
